module.exports = __webpack_public_path__ + "img/code.26dfd2c4.jpg";